import React, { useEffect, useState } from 'react';
import { RxCross1 } from 'react-icons/rx';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import authServices from '../../services/AuthServices';
import apiClient from '../../api/apiClient';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const ClearOutstanding = ({ isOpen, onClose }) => {
    // *********************************************** Employee  *****************************************************************
    const [UserData, setUserData] = useState([]);
    const [BankData, setBankData] = useState([]);
    const [formErrors, setFormErrors] = useState({});

    const [formData, setFormData] = useState({
        employee: null,
        banks: null,
        bankRefId: "",
        amount: "",
        mod: "",
        remark: "",
    });

    const token = authServices.getToken();

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (formData.employee === null || formData.employee === undefined) {
            errors.employee = true;
            isValid = false;
        }

        if (!formData.banks) {
            errors.banks = true;
            isValid = false;
        }
        if (!formData.bankRefId.trim()) {
            errors.bankRefId = true;
            isValid = false;
        }
        if (!formData.amount) {
            errors.amount = true;
            isValid = false;
        } else if (isNaN(Number(formData.amount))) {
            errors.amount = true;
            isValid = false;
        } else if (Number(formData.amount) <= 0) {
            errors.amount = true;
            isValid = false;
        }
        if (!formData.mod) {
            errors.mod = true;
            isValid = false;
        }
        if (!formData.remark.trim()) {
            errors.remark = true;
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };

    const fetchUsersByUserType = async () => {
        try {
            const response = await apiClient.get(`/api/admin/users/getAllByUserType`,
                {
                    params: {
                        userType: 'user',
                    },
                    headers: {
                        access_token: token,
                    },
                }
            );
            setUserData(response.data.data);
        }
        catch (error) {
            console.error('Error fetching users:', error);
            toast.error("Failed to fetch employee data");
        }
    };

    // *********************************************** Bank  *****************************************************************
    const fetchBank = async () => {
        try {
            const response = await apiClient.get(`/api/admin/bank/all`, {
                headers: {
                    access_token: token,
                },
            });
            setBankData(response.data.data);
        } catch (error) {
            console.error('Error fetching banks:', error);
            toast.error("Failed to fetch bank data");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors({ ...formErrors, [name]: false });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill all required fields correctly");
            return;
        }

        const data = {
            amount: formData.amount,
            bank: formData.banks,
            mode: formData.mod,
            bankRefId: formData.bankRefId,
            userId: formData.employee !== null ? { id: formData.employee } : null,
            service: "",
            remark: formData.remark,
        };

        try {
            const response = await apiClient.post(`/api/admin/outstanding/clearOutstanding`, data, {
                headers: {
                    access_token: token,
                    'Content-Type': 'application/json',
                },
            });
            if (response.data.Status === "SUCCESS") {
                toast.success(response.data.message);
                setFormData({
                    employee: null,
                    banks: null,
                    bankRefId: "",
                    amount: "",
                    mod: "",
                    remark: "",
                });
                setFormErrors({});
                onClose();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred";
            toast.error(errorMessage);
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchUsersByUserType();
            fetchBank();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-card">
                <div className='d-flex justify-content-between'>
                    <div className=''>
                        <h2 className="modal-title ps-2">Clear Outstanding</h2>
                    </div>
                    <div>
                        <button className="btn btn-light" onClick={onClose}><RxCross1 /></button>
                    </div>
                </div>
                <hr></hr>
                <div className="containers5 text-start">
                    <form onSubmit={handleSubmit}>
                        {/* Employee Dropdown */}
                        <div className="mb-2">
                            <label htmlFor="employee" className="form-label">
                                Employee
                            </label>
                            <Autocomplete
                                className={formErrors.employee ? "invalid-autocomplete" : ""}
                                disablePortal
                                options={UserData}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label=""
                                        error={formErrors.employee}
                                    />
                                )}
                                onChange={(event, value) => {
                                    setFormData({ ...formData, employee: value !== null ? value.id : null });
                                    if (formErrors.employee) {
                                        setFormErrors({ ...formErrors, employee: false });
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.name}
                                    </li>
                                )}
                            />
                        </div>

                        {/* Bank Dropdown */}
                        <div className="mb-2">
                            <label htmlFor="employee" className="form-label">
                                Bank
                            </label>
                            <Autocomplete
                                className={formErrors.banks ? "invalid-autocomplete" : ""}
                                disablePortal
                                options={BankData}
                                getOptionLabel={(option) => `${option.banks} - ${option.accountNumber}`}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label=""
                                        error={formErrors.banks}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.banks} - {option.accountNumber}
                                    </li>
                                )}
                                onChange={(event, value) => {
                                    setFormData({ ...formData, banks: value?.accountNumber || null });
                                    if (formErrors.banks) {
                                        setFormErrors({ ...formErrors, banks: false });
                                    }
                                }}
                            />
                        </div>

                        {/* Bank Ref-Id Field */}
                        <div className="mb-2">
                            <label htmlFor="bankRefId" className="form-label">
                                Bank Ref-Id
                            </label>
                            <input
                                type="text"
                                className={`form-control ${formErrors.bankRefId ? "is-invalid" : ""}`}
                                id="bankRefId"
                                name="bankRefId"
                                placeholder="Enter Bank Reference ID"
                                value={formData.bankRefId}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Amount Field */}
                        <div className="mb-2">
                            <label htmlFor="amount" className="form-label">
                                Amount
                            </label>
                            <input
                                type="text"
                                className={`form-control ${formErrors.amount ? "is-invalid" : ""}`}
                                id="amount"
                                name="amount"
                                placeholder="Enter amount"
                                value={formData.amount}
                                onChange={handleChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    if ((e.target.value.match(/\./g) || []).length > 1) {
                                        e.target.value = e.target.value.replace(/\.+$/, '');
                                    }
                                }}
                            />
                        </div>

                        {/* Mode Dropdown */}
                        <div className="mb-2">
                            <label htmlFor="mod" className="form-label">
                                Mode
                            </label>
                            <select
                                className={`form-select ${formErrors.mod ? "is-invalid" : ""}`}
                                id="mod"
                                name="mod"
                                value={formData.mod}
                                onChange={handleChange}
                            >
                                <option value="" disabled>
                                    Select payment mode
                                </option>
                                <option value="credit">Credit</option>
                                <option value="debit">Debit</option>
                            </select>
                        </div>

                        {/* Remark Field */}
                        <div className="mb-2">
                            <label htmlFor="remark" className="form-label">
                                Remark
                            </label>
                            <textarea
                                className={`form-control ${formErrors.remark ? "is-invalid" : ""}`}
                                id="remark"
                                name="remark"
                                rows="2"
                                placeholder="Enter any remarks"
                                value={formData.remark}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        {/* Submit Button */}
                        <button type="submit" className="btn btn-primary w-100 mt-4">
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ClearOutstanding;